import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20photography%20of%20modern%20fashion%20ecommerce%20items%20including%20sneakers%20hoodies%20caps%20watches%20and%20bags%20arranged%20in%20organized%20grid%20pattern%20on%20light%20oak%20wooden%20table%2C%20bright%20natural%20window%20light%20from%20above%2C%20clean%20contemporary%20aesthetic%20with%20geometric%20composition%2C%20soft%20neutral%20color%20palette%20mixing%20warm%20beige%20olive%20and%20charcoal%20tones%2C%20editorial%20product%20catalog%20style%20with%20deliberate%20spacing%20and%20crisp%20shadows&width=1800&height=900&seq=hero-bg-v3&orientation=landscape"
          alt="ACbuyspreadsheet - structured spreadsheet buying system for fashion and accessories"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-4xl">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-accent-500/90 text-background-50 mb-6 tracking-wide uppercase">
            ACBUY SPREADSHEET SYSTEM
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold font-heading text-white leading-[1.05] mb-5 max-w-3xl">
            ACbuyspreadsheet – The Ultimate Spreadsheet-Based Buying System for Faster, Smarter Online Purchasing
          </h1>

          <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mb-8">
            Discover how <strong>acbuyspreadsheet</strong> helps users track, organize, and optimize purchasing workflows 
            with a structured spreadsheet system. Browse categories, compare products, and start shopping smarter today.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-base font-bold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              ACbuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-base font-bold bg-background-50 text-primary-700 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line"></i>
              Buy It Now
            </a>
            <Link
              to="/article/what-is-acbuyspreadsheet"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-base font-semibold border-2 border-white/40 text-white hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-article-line"></i>
              Read Full Guide
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}